<div *ngIf="!isError">
  <mat-toolbar class="bar-filler"></mat-toolbar>
  <div>
    <div class="flex-container-center small-padding small-margin">
      <div class="item-image-holder flex-child">
        <img
          src="{{ itemHolder.MenuItem.Picture }}"
          class="item-image"
          onerror="this.src='assets/img/placeholder.png'"
        />
      </div>
      <div class="description-text">{{ itemHolder.MenuItem.Description }}</div>
    </div>
    <div>
      <div class="label center-text">
        {{ "Pages.MenuItem.Quantity" | translate }}
      </div>
      <div class="horizontal-center">
        <div class="flex-container-center">
          <button mat-icon-button color="accent" (click)="countTap(-1)">
            <mat-icon>remove</mat-icon>
          </button>
          <div mat-ripple class="cell-toggle" (click)="countTap(0)">
            <p>{{ itemHolder.MenuItem.ItemCount }}</p>
          </div>
          <button mat-icon-button color="accent" (click)="countTap(1)">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="small-margin">
      <mat-form-field class="fill-parent-width">
        <mat-label>{{ "Pages.MenuItem.Observation" | translate }}</mat-label>
        <input matInput [(ngModel)]="itemHolder.MenuItem.Comentary" />
      </mat-form-field>
    </div>
    <div>
      <div
        *ngFor="let detailGroupPack of itemHolder.DetailGroupPacks"
        class="detail-group"
      >
        <div class="sticky" id="{{ detailGroupPack.DetailGroup.ID }}">
          <div class="flex-container-center list-group-header disable-select">
            <div class="small-padding">
              <div class="list-group-header-label">
                {{ detailGroupPack.DetailGroup.Name }}
              </div>
              <div class="list-group-header-detail">
                {{ detailGroupPack.DetailGroup.Description }}
              </div>
              <div
                *ngIf="
                  detailGroupPack.DetailGroup.LimitSelection === true ||
                  detailGroupPack.DetailGroup.LimitMacroSelection === true
                "
                class="list-group-header-detail small-margin small-padding"
              >
                {{ detailGroupPack.LimitSelectionDescription }}
              </div>
              <div
                *ngIf="detailGroupPack.DetailGroup.Type == 1"
                class="list-group-header-detail"
              >
                ({{ "Pages.ComboItem.Mandatory" | translate }})
              </div>
            </div>
            <div class="filler"></div>
            <div
              *ngIf="detailGroupPack.DetailGroup.AlwaysShowList !== true"
              class="small-padding small-margin"
            >
              <button
                *ngIf="
                  detailGroupPack.ShowList === false &&
                  detailGroupPack.HasSelection === false
                "
                mat-stroked-button
                color="accent"
                (click)="showList(detailGroupPack, true)"
              >
                {{ "Pages.ComboItem.Choose" | translate }}
              </button>
              <button
                *ngIf="
                  detailGroupPack.ShowList === false &&
                  detailGroupPack.HasSelection === true
                "
                mat-stroked-button
                color="accent"
                (click)="showList(detailGroupPack, true)"
              >
                {{ "Pages.ComboItem.Change" | translate }}
              </button>
              <button
                *ngIf="detailGroupPack.ShowList === true"
                mat-icon-button
                color="accent"
                (click)="showList(detailGroupPack, false)"
              >
                <mat-icon>expand_less</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            detailGroupPack.ShowList === true ||
            detailGroupPack.DetailGroup.AlwaysShowList === true
          "
        >
          <div *ngFor="let detail of detailGroupPack.DetailList">
            <div class="disable-select">
              <div class="flex-container-center list-cell">
                <div
                  *ngIf="detail.ShowIcon"
                  class="detail-thumbnail-holder small-margin"
                >
                  <img
                    src="{{ detail.Icon }}"
                    class="detail-thumbnail"
                    onerror="this.src='assets/img/placeholder.png'"
                  />
                </div>
                <div class="small-padding">
                  <div class="list-cell-label">{{ detail.Name }}</div>
                </div>
                <div
                  *ngIf="detail.OutOfStock === false"
                  class="float-right flex-container-center disable-select"
                  (click)="detailTap(detail, detailGroupPack)"
                >
                  <div class="list-cell-price">{{ detail.PriceString }}</div>
                  <div
                    *ngIf="detail.Type == 0 && detail.MaxCount > 1"
                    mat-ripple
                    class="cell-toggle"
                  >
                    <p>{{ detail.CurrentCount }}</p>
                  </div>
                  <div
                    *ngIf="detail.Type == 0 && detail.MaxCount === 1"
                    mat-ripple
                    [ngClass]="{
                      'cell-toggle': detail.CurrentCount === 0,
                      'cell-toggle-filled': detail.CurrentCount === 1
                    }"
                  ></div>
                  <div
                    *ngIf="detail.Type == 1"
                    mat-ripple
                    [ngClass]="{
                      'cell-switch': detail.CurrentCount === 0,
                      'cell-switch-filled': detail.CurrentCount === 1
                    }"
                  ></div>
                </div>
                <div
                  *ngIf="detail.OutOfStock === true"
                  class="float-right flex-container-center disable-select"
                >
                  <div class="list-cell-price">
                    {{ "Pages.MenuItem.Unavailable" | translate }}
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-toolbar class="bar-filler">
      <mat-toolbar-row>
        <P></P>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <P></P>
      </mat-toolbar-row>
      <mat-toolbar-row *ngIf="isRedirect === true">
        <P></P>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  <mat-toolbar color="primary" class="top-bar" id="topbar">
    <button *ngIf="isRedirect !== true" mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button *ngIf="isRedirect === true" mat-icon-button (click)="goHome()">
      <mat-icon>home</mat-icon>
    </button>
    <div>{{ itemHolder.Name }}</div>
    <div class="filler"></div>
    <button
      mat-icon-button
      [cdkCopyToClipboard]="itemLink"
      (click)="copyLink()"
    >
      <mat-icon>link</mat-icon>
    </button>
  </mat-toolbar>
  <mat-toolbar
    *ngIf="showBottomBar === true"
    matRipple
    #bottomBar
    id="bottomBar"
    [matRippleDisabled]="true"
    [matRippleColor]="rippleColor"
    color="primary"
    class="bottom-bar"
  >
    <mat-toolbar-row>
      <div class="big-price-text">{{ currentPriceString }}</div>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <button
        mat-flat-button
        *ngIf="isClosed === false && status === 'new'"
        color="accent"
        disabled="{{ !canSave }}"
        (click)="save()"
        class="fill-parent-width"
      >
        {{ "Pages.MenuItem.Add" | translate }}
      </button>
      <button
        mat-flat-button
        *ngIf="isClosed === false && status === 'edit'"
        color="accent"
        disabled="{{ !canSave }}"
        (click)="save()"
        class="fill-parent-width"
      >
        {{ "Pages.MenuItem.Save" | translate }}
      </button>
      <button
        mat-flat-button
        *ngIf="isClosed === true"
        color="warn"
        (click)="showWorkTime()"
        class="fill-parent-width"
      >
        {{ "Pages.MenuItem.Closed" | translate }}
      </button>
    </mat-toolbar-row>
    <mat-toolbar-row *ngIf="isRedirect === true">
      <button
        mat-button
        color="accent"
        (click)="goHome()"
        class="fill-parent-width"
      >
        {{ "Pages.Combo.Home" | translate }}
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
<div *ngIf="isError" class="floating-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{
        "Pages.MenuItem.Error.Title" | translate
      }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>{{ "Pages.MenuItem.Error.Message" | translate }}</p>
    </mat-card-content>
    <mat-card-actions *ngIf="isRedirect">
      <button
        mat-raised-button
        color="accent"
        class="fill-parent-width"
        (click)="goHome()"
      >
        {{ "Pages.MenuItem.Error.Button" | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
